import actions from './actions';

const {
  GET_OFFER_CAR_BEGIN,
  GET_OFFER_CAR_SUCCESS,
  GET_OFFER_CAR_FAILED,
  ADD_OFFER_CAR_BEGIN,
  ADD_OFFER_CAR_SUCCESS,
  ADD_OFFER_CAR_FAILED,
  UPDATE_OFFER_CAR_BEGIN,
  UPDATE_OFFER_CAR_SUCCESS,
  UPDATE_OFFER_CAR_FAILED,
  DELETE_OFFER_CAR_BEGIN,
  DELETE_OFFER_CAR_SUCCESS,
  DELETE_OFFER_CAR_FAILED,
} = actions;

const initState = {
  offerCars: [],
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null,
};

const OfferCarReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_OFFER_CAR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_OFFER_CAR_SUCCESS:
      return {
        ...state,
        offerCars: data.offers,
        total: data.total || 0,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: false,
      };
    case GET_OFFER_CAR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_OFFER_CAR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_OFFER_CAR_SUCCESS:
      return {
        ...state,
        offerCars: data,
        total: state.total + 1,
        loading: false,
      };
    case ADD_OFFER_CAR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_OFFER_CAR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_OFFER_CAR_SUCCESS:
      return {
        ...state,
        offerCars: data,
        loading: false,
      };
    case UPDATE_OFFER_CAR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_OFFER_CAR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_OFFER_CAR_SUCCESS:
      return {
        ...state,
        offerCars: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_OFFER_CAR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default OfferCarReducer;
